import type { StoreAdmin, StoreRole } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";

/** One row: the account plus what the caller may do to it. */
export interface AdminMember {
  readonly admin: StoreAdmin;
  readonly canRemove: boolean;
  readonly canChangeRole: boolean;
}

export class ShopAdminsSectionState {
  readonly members = new RxList<AdminMember>();
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly email = new Rx("");
  readonly newRole = new Rx<StoreRole>("STAFF");
  /** Roles the caller may assign; empty for Staff. */
  readonly assignableRoles = new Rx<StoreRole[]>([]);
  readonly adding = new Rx(false);
  readonly changingId = new Rx<string | null>(null);
  readonly removingId = new Rx<string | null>(null);
  readonly error = new Rx<string | null>(null);
  /** The success sentence, once someone was added. */
  readonly added = new Rx<string | null>(null);
}

export abstract class ShopAdminsSectionActions {
  abstract setEmail(value: string): void;
  abstract setNewRole(role: StoreRole): void;
  abstract add(): Promise<void>;
  abstract changeRole(admin: StoreAdmin, role: StoreRole): Promise<void>;
  /** The view confirms first; this removes. */
  abstract remove(admin: StoreAdmin): Promise<void>;
}
